import React, { useState, useCallback, useEffect } from 'react';
import block from 'bem-cn';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';

import Button from 'components/Button';
import CheckBox from 'components/CheckBox';
import InputDate from 'components/InputDate/desktop';
import DaysFilter from 'features/reports/view/desktop/DaysFilter';

import { actions } from 'features/finance';

import './FilterBlock.scss';

const b = block('filter-block-my-debt');

const FilterBlock = ({ count, currentPage, isMobile, onPageClick }) => {
  const locale = useSelector(state => state.locale.locale);
  const dispatch = useDispatch();
  const [date, setDate] = useState({
    beginDate: new Date(dayjs().add(-3, 'day')),
    endDate: new Date(dayjs()),
    onlyUserTransfers: false,
    myOperations: false,
    onlyDeposits: false,
    onlyWithdrawals: false,
  });
  const [activeDay, setActiveDay] = useState('');

  const onChangeBeginDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate({ ...date, beginDate: value });
    }
    setActiveDay('');
  };

  const onChangeEndDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate({ ...date, endDate: value });
    }
  };

  const onChangeOnlyUser = value => {
    setDate({ ...date, onlyUserTransfers: value });
  };

  const onChangeMyOperations = value => {
    setDate({ ...date, myOperations: value });
  };

  const onChangeOnlyDeposits = value => {
    setDate({ ...date, onlyDeposits: value });
  };

  const onChangeOnlyWithdrawals = value => {
    setDate({ ...date, onlyWithdrawals: value });
  };

  const handleSearch = useCallback(() => {
    const requestedData = {
      count,
      page: currentPage,
      ...date,
    };
    dispatch(actions.getFinanceHistory(requestedData));
  });

  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, currentPage]);

  const onClickSearch = () => {
    onPageClick(0);
    handleSearch();
  };

  const onChangeActiveDay = useCallback(
    dayFilter => {
      setActiveDay(dayFilter);
      setDate({
        ...date,
        beginDate: dayFilter.value,
        endDate: dayFilter.value2,
      });
    },
    [date],
  );

  return (
    <div className={b()}>
      <div className={b('header')}>{locale.filter}</div>
      <div className={b('wrapper')}>
        <div className={b('date-container')}>
          <DaysFilter activeDay={activeDay} setActiveDay={onChangeActiveDay} />
          <div className={b('or')}>{locale.or}</div>
          <div className={b('date')}>
            <div className={b('date-row')}>
              <div className={b('title')}>{locale.dateFrom}</div>
              <div className={b('date-input')}>
                <InputDate selected={date.beginDate} onChange={onChangeBeginDate} />
              </div>
            </div>
            <div className={b('date-row')}>
              <div className={b('title')}>{locale.dateTo}</div>
              <div className={b('date-input')}>
                <InputDate selected={date.endDate} onChange={onChangeEndDate} />
              </div>
            </div>
          </div>
        </div>
        <div className={b('checkboxes-container')}>
          <label className={b('checkbox-wrapper')}>
            <div className={b('checkbox')}>
              <CheckBox checked={date.myOperations} onChange={() => onChangeMyOperations(!date.myOperations)} />
            </div>
            {locale.myCount}
          </label>
          <label className={b('checkbox-wrapper')}>
            <div className={b('checkbox')}>
              <CheckBox checked={date.onlyUserTransfers} onChange={() => onChangeOnlyUser(!date.onlyUserTransfers)} />
            </div>
            {locale.myOperations}
          </label>
          <label className={b('checkbox-wrapper')}>
            <div className={b('checkbox')}>
              <CheckBox checked={date.onlyDeposits} onChange={() => onChangeOnlyDeposits(!date.onlyDeposits)} />
            </div>
            {locale.deposits}
          </label>
          <label className={b('checkbox-wrapper')}>
            <div className={b('checkbox')}>
              <CheckBox
                checked={date.onlyWithdrawals}
                onChange={() => onChangeOnlyWithdrawals(!date.onlyWithdrawals)}
              />
            </div>
            {locale.withdrawals}
          </label>
        </div>
      </div>
      <div className={b('button')}>
        <div className={b('title')} style={{ color: 'transparent' }}>
          transparent placeholder
        </div>
        <Button size="low" callBack={() => onClickSearch()} text={locale.acceptFilter} />
      </div>
    </div>
  );
};

export default FilterBlock;
